import { ReactSVG } from "react-svg";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

import { WarehouseAddressRow } from "./types";

export const WAREHOUSE_ADDRESS_ROW_ID = "warehouse-address";

/** Stupci adrese u čarobnjaku skladišta — isti izgled kao adrese u čarobnjaku kontakta. */
export const WAREHOUSE_EDIT_ADDRESS_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>) => void
): Column[] => [
  {
    title: "Adresa",
    field: "",
    type: ColumnTypes.custom,
    render: (row: WarehouseAddressRow) => {
      return (
        <div>
          <span className="text-md font-medium text-slate-600">{row.line1 || "-"}</span>
          {row.line2 && <div className="text-xs text-slate-500">{row.line2}</div>}
        </div>
      );
    },
  },
  {
    title: "Mjesto",
    field: "",
    type: ColumnTypes.custom,
    render: (row: WarehouseAddressRow) => {
      return (
        <div className="text-sm text-slate-900 truncate">
          {row.postalCode} {row.city}
        </div>
      );
    },
  },
  {
    title: "Država",
    field: "",
    type: ColumnTypes.custom,
    render: (row: WarehouseAddressRow) => {
      return <div className="text-sm text-slate-900 truncate">{row.country}</div>;
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: () => {
      return (
        <div onClick={handleDeleteClick} className="flex justify-end items-center h-[30px]">
          <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
        </div>
      );
    },
  },
];
